import React, {} from 'react';
import ReactDOM from 'react-dom';
// import ClaroApp from 'ClaroApp';
// import 'lazysizes';
// import a plugin
// import 'lazysizes/plugins/parent-fit/ls.parent-fit';


// Sass
import 'Sass/main.sass'
import 'Sass/includes/Components/modules/channelGuide.sass'

import GuiaCanales from 'Components/Organisms/Personas/GuiaCanales'
import reportWebVitals from './reportWebVitals';



// function Loading (){
//   return(
//       <div>
//           Loading
//       </div>
//   )
// }

ReactDOM.render(
  <React.StrictMode>
    {/* <ClaroApp /> */}
    {/* <TestContainer4/> */}
    <GuiaCanales />
  </React.StrictMode>,
  document.getElementById('react_guia_canales')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
